module.exports = __webpack_public_path__ + "static/media/img-axum-product-2@3x.97ebb34f.png";